import React from "react";
import { PhoneMockUp } from "../../assets/images";

type FirstSplashScreenProps = {
  handleNext: () => void;
};
const FirstSplashScreen: React.FC<FirstSplashScreenProps> = ({
  handleNext,
}) => {
  return (
    <div className="flex h-full items-center bg-midGreen justify-center w-full flex-col relative">
      <div className="px-7 h-[40%] font-BRFirma w-full pt-12">
        <div className="text-white text-[20px]">No 1 market place</div>
        <div className=" w-full">
          <p className="text-[15px] font-medium text-white break-words whitespace-pre-line text-pretty mt-2">
            The town square for the Ecomoto community-lessors and lessees.
          </p>
          <p className="text-[15px] font-medium text-white break-words whitespace-pre-line text-pretty">
            Here, you can socialize, network, and share content (video,
            pictures, infographics, etc.)
          </p>
          <div
            className="items-center mt-3 cursor-pointer bg-white flex justify-center text-center font-Poppins font-medium text-lg w-[335px] h-[50px] text-midGreen rounded-2xl"
            onClick={handleNext}
          >
            Next
          </div>
        </div>
      </div>
      <div className="w-[90%] flex justify-center h-[60%] z-10 pt-6">
        <img src={PhoneMockUp} alt="" className="h-full w-[70%]" />
      </div>
    </div>
  );
};

export default FirstSplashScreen;
